module.exports = __webpack_public_path__ + "img/10.d0b26769.jpg";